<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save"   @del="delall" @imp="imp"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <div style="margin-top: 2px">
                    <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.batchdel">{{$t('getapi[7241]')}}</el-button>
                </div>
                <wTable
                        id="xpane-0"
                        :data="dataSet"
                        :loading="loading"
                        queryData="SchQuotationAuditViewInfo"
                        :filter_language="['Status']"
                        :header="tableHeader"
                        :option="tableOption"
                        @handleSelectionChange="handleSelectionChange"
                        @edits="editInfo"
                        @rowdblclick="openEdit"
                        :row-class-name="tableRowClassName"
                        ref="singleTable"
                ></wTable>
                    <!--<el-table
                            :data="dataSet"
                            ref="singleTable"
                            v-loading="loading"
                            :highlight-current-row="true"
                            show-overflow-tooltip="true"
                            border
                            stripe
                            size="mini"
                            @row-click="editInfo"
                            @row-dblclick="openEdit"
                            @selection-change="handleSelectionChange"
                            :height="tableHeight"
                            header-row-class-name="headerclass"
                            style="width: 100%;"
                    >
                        <el-table-column type="selection"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Doc_Num" :label="$t('getapi[871]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Status" :label="$t('getapi[552]')">
                            <template slot-scope="scope">
                                <span v-if="scope.row.Status==0">生成</span>
                                <span v-if="scope.row.Status==1">审核中</span>
                                <span v-if="scope.row.Status==2">批准</span>
                                <span v-if="scope.row.Status==3">驳回</span>
                            </template>
                        </el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_Name" :label="$t('getapi[1197]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Vender_Code" :label="$t('getapi[1196]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Tax_Rate" :label="$t('getapi[1225]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_person" :label="$t('getapi[1616]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[409]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_person" :label="$t('getapi[2591]')"></el-table-column>
                        <el-table-column show-overflow-tooltip prop="Modify_time" :label="$t('getapi[734]')"></el-table-column>
                    </el-table>-->
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div style="display: flex;">
                        <el-button type="primary" size="mini" :disabled="!btn.commitbtn" @click="commitup()" >{{$t('getapi[6468]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click.native="downloadModel">{{$t('getapi[6111]')}}</el-button>
                        <el-upload
                                class="upload-demo"
                                ref="upload"
                                :action="uploadurl"
                                :on-preview="handlePreview"
                                :on-remove="handleRemove"
                                :on-change="handleChange"
                                :on-success="handleSuccess"
                                :on-error="handleError"
                                :file-list="fileList"
                                :disabled="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3) || dataDetail.Master.Vender_Code == ''"
                                style="margin-left: 8px"
                        >
                            <el-button slot="trigger" size="mini" type="primary" :disabled="(dataDetail.Master.Status != 0 && dataDetail.Master.Status != 3) || dataDetail.Master.Vender_Code == ''">{{$t('getapi[436]')}}</el-button>
                        </el-upload>
                    </div>
                    <div style="width:600px;min-width:600px">
                        <table>
                        <tr>
                            <td style="width:50px;min-width:50px">
                                <span>{{$t('getapi[871]')}}</span>
                            </td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Master.Doc_Num" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:50px;min-width:50px">
                                <span>{{$t('getapi[409]')}}</span>
                            </td>
                            <td style="width:150px;min-width:150px">
                                <el-input type="text" size="mini" v-model="dataDetail.Master.Create_time" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:50px;min-width:50px">
                                <span>{{$t('getapi[1225]')}}</span>
                            </td>
                            <td style="width:50px;min-width:50px">
                                <el-input  type="text" size="mini" v-model="dataDetail.Master.Tax_Rate" :readonly="true" class="readO"></el-input>
                            </td>
                            <td style="width:50px;min-width:50px">
                                <span>{{$t('getapi[552]')}}</span>
                            </td>
                            <td style="width:50px;min-width:50px">
                                <el-input  type="text" size="mini" style="width: 80px;"  :value="expStatus(dataDetail.Master.Status)" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <span>{{$t('getapi[1287]')}}</span>
                            </td>
                            <td>
                                <routejump :urlNo="26">
                                <el-input type="text" :disabled="!btn.commit" class="mcolor" size="mini" readonly v-model="dataDetail.Master.Vender_Code" >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectsupplier"></i>
                                </el-input>
                                </routejump>
                            </td>
                            <td>
                                <span>{{$t('getapi[1197]')}}</span>
                            </td>
                            <td  colspan="3">
                                <el-input  type="text" size="mini" v-model="dataDetail.Master.Vender_Name" :readonly="true" class="readO"></el-input>
                            </td>
                            <td>
                                <span>{{$t('getapi[1338]')}}</span>
                            </td>
                            <td>
                                <el-input  type="text" size="mini"  v-model="dataDetail.Master.Currency_Code" :readonly="true" class="readO"></el-input>
                            </td>
                        </tr>
                    </table>
                    </div>
                    <el-tabs :tab-position="'top'" style="margin-top: 5px" >
                    <el-tab-pane :label="$t('getapi[6731]')" name="0">
                        <div class="btnnowrap">
                            <el-button type="primary"  size="mini" icon="el-icon-circle-plus" @click="addline" :disabled="!btn.addline">{{$t('getapi[878]')}}</el-button>
                            <el-button type="primary"  size="mini" icon="el-icon-delete-solid" @click="delline" :disabled="!btn.delline">{{$t('getapi[40]')}}</el-button>
                        </div>
                        <el-table
                                id="xdetilpane-0"
                                :data="dataDetail.DTlines"
                                ref="singleTable1"
                                v-loading="loading1"
                                :highlight-current-row="true"
                                border
                                stripe
                                size="mini"
                                :row-class-name="tableRowClassNameM"
                                @selection-change="handleSelectionChangeM"
                                :height="tableHeight - 140"
                                header-row-class-name="headerclass"
                                @sort-change="sortChange"
                                style="width: 100%; margin-top:5px"
                        >
                            <el-table-column type="selection"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Err_Msg" :label="$t('getapi[477]')" v-if="showError">

                            </el-table-column>
                            <el-table-column  prop="part_code" :label="$t('getapi[112]')" width="150" sortable="custom">
                                <template slot-scope="scope">
									<el-input 
										v-model="scope.row.part_code"
                                        style="width: 150px;"
										class="mcolor"
										readonly
                                        v-if="btn.commit"
									>
                                     <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart(scope)"></i>
                                    </el-input>
                                    <span v-if="!btn.commit">{{scope.row.part_code}} </span>
								</template>
                            </el-table-column>
                            <el-table-column prop="routing_sequence_no" :label="$t('getapi[573]')" width="70">
                                <template slot-scope="scope" >
                                    <el-input type="text" :disabled="!btn.commit" class="mcolor" size="mini" readonly v-model="scope.row.routing_sequence_no" >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectRouting(scope)"></i>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="PriceRemark" :label="$t('getapi[7973]')" width="100">
                                <template slot-scope="scope">
                                    <!--<el-input v-if="btn.commit" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.PriceRemark"></el-input>-->
                                    <el-select v-if="btn.commit"  v-model="scope.row.PriceRemark" size="mini">
                                        <el-option v-for="item in scope.row.pricearr" :key="item.key" :label="item.value"
                                                   :value="item.key"></el-option>
                                    </el-select>
                                    <span v-if="!btn.commit">{{scope.row.PriceRemark}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="PriceRemark2" :label="$t('getapi[12608]')" width="70" v-if="userData.Login_DB == 'MLXY'">
                            </el-table-column>
                            <el-table-column :label="$t('getapi[12609]')" width="70" align="right">
                                <template slot-scope="scope" v-if="userData.Login_DB == 'MLXY' && scope.row.PriceRemark && scope.row.PriceRemark2">
                                    <span v-if="(scope.row.PriceRemark / scope.row.PriceRemark2) > 1" style="color: red">{{(((scope.row.PriceRemark / scope.row.PriceRemark2 * 10000) / 100.00)-100).toFixed(2)}}%</span>
                                    <span v-if="(scope.row.PriceRemark / scope.row.PriceRemark2) < 1" style="color: #67C23A">{{((Math.abs( scope.row.PriceRemark2 - scope.row.PriceRemark)/ scope.row.PriceRemark * 10000) / 100.00).toFixed(2)}}%</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Old_Unit_Price" :label="$t('getapi[6442]')" width="70" align="right"></el-table-column>
                            <el-table-column :label="$t('getapi[8172]')" width="70" align="right">
                                <template slot-scope="scope" v-if="(scope.row.New_Unit_Price || scope.row.net_price) && scope.row.Old_Unit_Price">
                                    <span v-if="scope.row.New_Currency_Code != scope.row.Old_Currency_Code && getRiseAndFallRate(scope.row) >= 0" style="color: red">{{getRiseAndFallRate(scope.row)}}%</span>
                                    <span v-if="scope.row.New_Currency_Code != scope.row.Old_Currency_Code && getRiseAndFallRate(scope.row) < 0" style="color: #67C23A">{{Math.abs(getRiseAndFallRate(scope.row))}}%</span>
                                    <span v-if="$limits.fnIsEmpty(scope.row.net_price) && (scope.row.New_Unit_Price / scope.row.Old_Unit_Price) > 1" style="color: red">{{(((scope.row.New_Unit_Price / scope.row.Old_Unit_Price * 10000) / 100.00)-100).toFixed(2)}}%</span>
                                    <span v-if="!$limits.fnIsEmpty(scope.row.net_price) && (scope.row.net_price / scope.row.Old_Unit_Price) > 1" style="color: red">{{(((scope.row.net_price / scope.row.Old_Unit_Price * 10000) / 100.00) - 100).toFixed(2)}}%</span>
                                    <span v-if="$limits.fnIsEmpty(scope.row.net_price) && (scope.row.New_Unit_Price / scope.row.Old_Unit_Price) < 1" style="color: #67C23A">{{((Math.abs( scope.row.Old_Unit_Price - scope.row.New_Unit_Price)/ scope.row.New_Unit_Price * 10000) / 100.00).toFixed(2)}}%</span>
                                    <span v-if="!$limits.fnIsEmpty(scope.row.net_price) && (scope.row.net_price / scope.row.Old_Unit_Price) < 1" style="color: #67C23A">{{((Math.abs(scope.row.Old_Unit_Price - scope.row.net_price) / scope.row.net_price * 10000) / 100.00).toFixed(2)}}%</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="New_Currency_Code" :label="$t('getapi[1338]')"></el-table-column>
                            <el-table-column prop="New_Unit_Price" :label="$t('getapi[1410]')" width="70" align="right">
                                <template slot-scope="scope" >
                                    <el-input v-if="btn.commit" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.New_Unit_Price" @input="SetLineStatus1(scope)" :disabled='scope.row.linestatus==2' ></el-input>
                                    <span v-if="!btn.commit">{{scope.row.New_Unit_Price}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="MOQ" label="MOQ" width="70" align="right">
                                <template slot-scope="scope" >
                                    <el-input v-if="btn.commit" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.MOQ" @input="SetLineStatus1(scope)" :disabled='scope.row.linestatus==2' ></el-input>
                                    <span v-if="!btn.commit">{{scope.row.MOQ}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="order_addqty" :label="$t('getapi[164]')" width="70" align="right">
                                <template slot-scope="scope" >
                                    <el-input v-if="btn.commit" type="number" autocomplete="off" title="" @mousewheel.native.prevent v-model="scope.row.order_addqty" :disabled='scope.row.linestatus==2' ></el-input>
                                    <span v-if="!btn.commit">{{scope.row.order_addqty}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="net_price" :label="$t('getapi[6732]')" width="100" align="right">
                                <template slot-scope="scope" >
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="btn.commit" v-model="scope.row.net_price"  @input="caculateTax(scope)" :disabled='scope.row.linestatus==1'></el-input>
                                    <span v-if="!btn.commit">{{scope.row.net_price}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="batch_floor_limit" label="MOQ2" width="70" align="right">
                                <template slot-scope="scope" >
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="btn.commit" v-model="scope.row.batch_floor_limit" @input="SetLineStatus2(scope)" :disabled='scope.row.linestatus==1'></el-input>
                                    <span v-if="!btn.commit">{{scope.row.batch_floor_limit}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="Process_Remark" :label="$t('getapi[6702]')" width="120">
                                <template slot-scope="scope" >
                                    <el-input  type="text" v-if="btn.commit" v-model="scope.row.Process_Remark"></el-input>
                                    <span v-if="!btn.commit">{{scope.row.Process_Remark}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Area" :label="$t('getapi[139]')" width="70">
                            </el-table-column>
                            <el-table-column prop="Shipment_Cycle" :label="$t('getapi[6733]')" width="80" align="right">
                                <template slot-scope="scope" >
                                    <el-input  type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="btn.commit" v-model="scope.row.Shipment_Cycle"></el-input>
                                    <span v-if="!btn.commit">{{scope.row.Shipment_Cycle}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="PriceEffective_Date" :label="$t('getapi[1339]')" width="100">
                                <template slot-scope="scope" >
                                    <el-date-picker v-model="scope.row.PriceEffective_Date" type="date" v-if="btn.commit"></el-date-picker>
                                    <span v-if="!btn.commit">{{scope.row.PriceEffective_Date}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Routing_Name" :label="$t('getapi[3331]')" width="70">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Item_Code" :label="$t('getapi[3437]')" width="70">
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Routing_CreatePerson" :label="$t('getapi[6403]')" width="70">
                            </el-table-column>
                            <el-table-column prop="Remarks" :label="$t('getapi[143]')" width="70">
                                <template slot-scope="scope" >
                                    <el-input  type="text" v-if="btn.commit" v-model="scope.row.Remarks"></el-input>
                                    <span v-if="!btn.commit">{{scope.row.Remarks}} </span>
                                </template>
                            </el-table-column>
                            <el-table-column field="ce_flag" :label="$t('getapi[8047]')" sortable="custom" width="100">
                                <template slot-scope="scope">
                                    <el-checkbox size="mini" v-model="scope.row.ce_flag"  :true-label=1 :false-label=0 :disabled="true"></el-checkbox>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[6734]')" name="1">
                        <!--<div class="btnnowrap">
                        <el-button type="primary" :disabled="!btn.commit&&dataDetail.IsEdit==1"  size="mini" @click="selectemployee">{{ $t('getapi[438]') }}</el-button>
                        &lt;!&ndash; <el-button type="primary" :disabled="!btn.commit"  size="mini" @click="delbatch" >{{$t('getapi[1522]') }}</el-button> &ndash;&gt;
                        </div>-->
                        <el-table
                                :data="dataDetail.DTAuditInfo"
                                ref="AuditTable"
                                v-loading="loading2"
                                :highlight-current-row="true"
                                :row-class-name="tableRowClassNameRight"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - 140"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:5px"
                        >
                            <el-table-column show-overflow-tooltip prop="Sort" :label="$t('getapi[1297]')" width="100"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[4043]')" width="100"></el-table-column>
                            <el-table-column prop="Audit_Status" :label="$t('getapi[6470]')" width="100">
                                <template slot-scope="scope">
											<span v-if="scope.row.Audit_Status==0">{{$t('getapi[1233]')}}</span>
                                            <span v-if="scope.row.Audit_Status==1">{{$t('getapi[3607]')}}</span>
                                            <span v-if="scope.row.Audit_Status==2">{{$t('getapi[6228]')}}</span>
								</template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Msg" :label="$t('getapi[6735]')" ></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_Date" :label="$t('getapi[732]')" width="200"></el-table-column>
                            <el-table-column fixed="right" :label="$t('getapi[6048]')" width="80">
                            <template slot-scope="scope">
                                <el-button   v-if="dataDetail.Master.Status==1&&scope.row.superior_flag==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& scope.row.Sort == dataDetail.AuditSort" @click.native.prevent="Audit(scope,1)" type="text" size="small">{{$t('getapi[941]')}}</el-button>
                                <el-button   v-if="dataDetail.Master.Status==1&&scope.row.superior_flag==1&&(scope.row.Audit_Status == 0 || scope.row.Audit_Status == 2)&& scope.row.Sort == dataDetail.AuditSort" @click.native.prevent="Audit(scope,2)" type="text" size="small">{{$t('getapi[6228]')}}</el-button>
                                <el-button   v-if='(dataDetail.Master.Status==0&&dataDetail.Master.Item_Code!=null&&dataDetail.Master.Item_Code.indexOf("通用")!=-1)' @click.native.prevent="delbatch(scope.$index)" type="text" size="small">{{$t('getapi[40]')}}</el-button>
                            </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    </el-tabs>
                </div>
            </li>
        </ul>
        <el-row class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="SchQuotationAuditViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[6561]')" queryData="SchQuotationAuditViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>
        <!--选择客户代码-->
        <selector :isVisible="false" :selectType="2" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetSALCustomerDataList'" @callback="getcus" ref="customer"></selector>
        <!--选择供应商编码-->
        <selector :isVisible="false" :selectType="1" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetSupplyPopuDataList'" @callback="getsupplier" ref="supplier"></selector>
        <!--选择项目-->
        <selector :isVisible="false" :selectType="4" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetEngItemDataList'" @callback="getproject" ref="project"></selector>
        <!-- 采购件弹框 -->
        <selector :isVisible="false" :isBatch=false :selectType="11" :isSplitPage=true :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpart" ref="part"></selector>
         <!-- 选择审核人员 -->
        <selector :isBatch=true :isSplitPage=true :selectType="1"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployee" ref="employee"></selector>

        <!--选择外协工序-->
        <selector :isVisible="false" :selectType="1" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetRoutingDataList'" @callback="getRounting" ref="Rounting"></selector>
        <el-dialog v-dialogDrag :title="$t('getapi[6472]')" :visible.sync="CloseDialogVisible" width="30%">
            <el-input type="textarea" :rows="5" v-model="resontxt"></el-input>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="mt2">{{$t('getapi[1146]')}}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
import { Loading } from 'element-ui';
    export default {
        name: 'wxpricereq',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3 - Common.reduceTableHeight3,
                    maxHeight: this.$windowSize.tableHeight3,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            },
        },
        data() {
            return {
                tableHeader: [],
                CloseDialogVisible:false,
                resontxt:'',
                tmprow:{},
                partindex:0,
                Currency_Code:'CNY',
                visReplacePart:false,
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                user:[],
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('wxpricereq'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                loading: false,
                loading1: false, // 主表加载状态
                loading2: false, // 主表加载状态
                IsEditPrice:false,//是否可以编辑不含税单价
                RStartName:'',//前端缓存外协工序名
                changeHeight:57,
                sort:1,
                dataDetail:{
                    IsEdit:1,
                    Master:{},
                    DTAuditInfo:[],
                    DTlines:[]
                },
                oldDataDetail:'',
                SignList: [],
                multipleSelection: [],//左侧主表选择
                multipleSelectionMain: [],
                selectData1: [],
                selectData2: [],
                selectData3: [],
                selectData4: [],
                btn:{
                    commitbtn:false,
                    commit:false,
                    addline:false,
                    delline:false,
                    batchdel:false,
                },
                srType: [],//sr类别
                orderDetail: {
                    plancode: '',
                    issrso: '0',
                    isnewflag: '0',
                    sotype: '0',
                    flag: 1,
                    issselfbadflag: '0',
                    iscontinue: 0,
                },
                visOrder: false,
                orderType: 1,
                pickoption:{
                    disabledDate:(time)=> {
                        return time.getTime() < Date.now() //-1 * 24 * 3600 * 1000
                    }
                },
                oldrow: '',
                iscontinuedblclick: true,
                rowindex: '',
                uploadurl: '',
                fileList: [],
                file: null,
                showError: false,
                timeId: null,
                code: '',
                linepricearr: [],//行基价数组
                scrollTop:0,
                scrollTop1:0,
                changeRateArr:[],
            };
        },
        beforeMount() {
            let that = this;
            that.fileList = [];
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            let token = that.userData.token;
            that.uploadurl = Common.Url + '/ISS/PQAudit/GetTSchQModelData?token=' + token;
        },
        watch:{
            dataSet: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initForm(0)
                })
            },
            dataDetail: function(){
                let that = this
                that.$nextTick(function() {
                    that.$processdata.initFormRight(0)
                })
            }
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                }, 13)
            })
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('wxpricereq', that);
            that.$limits.dragControllerDiv();
            that.getExchangeRate()
            that.$http.urlpost('/Basic/Iss/Iss_Routing_PriceDataList', '', function(res) {
                if (res.Success == 1) {
                    let arr = res.DataContent;
                    that.linepricearr = []
                    for(let i = 0;i<arr.length;i++){
                        that.linepricearr = [...that.linepricearr,{
                            name:arr[i].WORKPROC_NAME,
                            data:[{
                                key: arr[i].Price1,
                                value:arr[i].Price1
                            },{
                                key: arr[i].Price2,
                                value:arr[i].Price2
                            },{
                                key: arr[i].Price3,
                                value:arr[i].Price3
                            },{
                                key: arr[i].Price4,
                                value:arr[i].Price4
                            }]
                        }]
                    }
                }
            });
            that.confirmAdd();
        },

        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('SchQuotationAuditViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6561]"),this.$t("getapi[14]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                if(!this.$limits.menuvisible("plv2", 522, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 521, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 522, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 522, 1) == 2) {
                        if (that.$limits.authority('plv3', 522,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 522,1) == 1) {
                            //编辑级
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                        if (that.$limits.authority('plv3', 522, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Master.Exclusively_ID)) {
                                if(that.dataDetail.Master.Status==0 || that.dataDetail.Master.Status==3){
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export,del');
                                }else{
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                }

                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.commit = false;
                that.btn.addline=false;
                that.btn.delline = false;
                that.btn.commitbtn = false;
                that.btn.batchdel = false
                if(that.multipleSelection.length > 0){
                    that.btn.batchdel = that.multipleSelection.every(val => {
                        return (val.Status == 0 || val.Status == 3)
                    });
                }
                if(that.$limits.fnIsEmpty(that.dataDetail.Master.Exclusively_ID)){
                    if(that.dataDetail.IsEdit==1){//如果是新建，全亮
                        that.btn.commitbtn = false;//提交不亮
                        that.btn.commit = true;
                        that.btn.addline =true;
                        that.btn.delline = true;
                    }
                    return;
                }
                if(that.dataDetail.Master.Status==0||that.dataDetail.Master.Status==3){
                    that.btn.commit = true;
                    that.btn.addline =true;
                    that.btn.delline = true;
                    console.log('权限'+ that.$limits.authority('plv4', 523, 1))
                    if(that.$limits.authority('plv4', 523, 1) > 0){
                        that.btn.commitbtn = true;
                    } else {
                        that.btn.commitbtn = false;
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save',true);
                }else{
                    that.btn.commit = false;
                    that.btn.addline=false;
                    that.btn.delline = false;
                     that.btn.commitbtn = false;
                    that.$refs.SetBtn.SetOneBtnEnable('save',false);
                }

            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            changehh(){
                let that = this;
                var bbox = document.getElementsByClassName('box');
                if(that.dataDetail.Master.Doc_Reason==3){
                    bbox[0].style.height = '165px';
                    that.changeHeight = 0;
                }else{
                    bbox[0].style.height = '108px';
                     that.changeHeight = 57;
                }

            },
            selectreason(){
                let that = this;
                that.changehh();
                
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('wxpricereq',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            getcus(data){
                let that = this;
                let token = that.userData.token;
                let geturl = Common.Url + '/Pur/Approval/DataListByCustomer_ID?token=' + token+"&Customer_ID="+data.customer_id;
                that.$http.gets(geturl, '', function (res) {
                if (res.data.Success == 1) {
                    that.dataDetail.DTAuditInfo=[];
                    if(that.$limits.fnIsEmpty(res.data.DataContent)){
                        that.$message.warning(that.$t('getapi[8802]'));//该项目没有对应的审批模板，请先创建
                    }else{
                        for(let i=0;i<res.data.DataContent.length;i++){
                            let obj={
                                Exclusively_ID:res.data.DataContent[i].exclusively_id,
                                Relation_IID:res.data.DataContent[i].relation_rule_no,
                                Sort:res.data.DataContent[i].line_no,
                                Audit_Person:res.data.DataContent[i].auditperson,
                                userID:res.data.DataContent[i].userid,
                                Audit_Status:0,
                                Audit_Date:'',
                                Audit_Msg:''
                            }
                            that.dataDetail.DTAuditInfo.push(obj);
                        }
                    }
                }
                });
                that.dataDetail.Master.Customer_ID = data.customer_id;
                that.dataDetail.Master.Customer_Name = data.customer_name;
            },
            getproject(data){
                let that = this;
                that.dataDetail.DTlines[that.rowindex].Item_Code = data.item_code;
                that.dataDetail.DTlines[that.rowindex].Item_Name = data.item_name;
            },
            mt2(){
                let that = this;
                that.tmprow.Audit_Msg=that.resontxt;
                that.tmprow.Audit_Status=2;
                that.tmprow.Audit_Date = that.$limits.getDateTime();
                that.CloseDialogVisible=false;
                that.$http.urlpost('/ISS/PQAudit/ISSQAuditInfoSetStatus', that.tmprow, function (res) {
                if (res.Success == 1) {
                that.getView();
                that.getDetail(res.UniqueNum);
                that.resontxt='';
                that.$message.success(that.$t('getapi[8803]'));//'驳回成功！'
                } 
                
                });
            },
            Audit(scope,flag){
                let that =this;
                let msgs = that.$t('getapi[8606]');//'确认审核通过吗?'
                if(flag==2){
                    msgs = that.$t('getapi[8804]')//'确认驳回吗?';
                    that.CloseDialogVisible=true;
                    that.tmprow = scope.row;
                    that.resontxt = '';
                    return;
                }
                this.$confirm(msgs, that.$t('getapi[194]'), {
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        scope.row.Audit_Status=flag;
                        scope.row.Audit_Date =  that.$limits.getDateTime();
                        that.$http.urlpost('/ISS/PQAudit/ISSQAuditInfoSetStatus', scope.row, function (res) {
                        if (res.Success == 1) {
                            that.getView();
                            that.getDetail(res.UniqueNum);
                            if(flag==2)that.$message.success(that.$t('getapi[8803]'));//'驳回成功！'
                            else that.$message.success(that.$t('getapi[1456]'));//'审核成功！'
                        } 
                        });


                    })
                    .catch(() => {
                        // this.$message({
                        //     type: 'info',
                        //     message: '已取消删除'
                        // });
                    });
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'SchQuotationAuditViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.pageIndex = 1;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },

            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/ISS/PQAudit/ISSQAuditList', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        }
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                    //that.authority(1);
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.Exclusively_ID){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 522, 1)){
                        return
                    }
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.DTlines.length;i++){
                        delete datacopy.DTlines[i]['index'];
                        delete datacopy.DTlines[i]['pricearr'];
                    }
                    for(let i = 0;i<datacopy.DTAuditInfo.length;i++){
                        delete datacopy.DTAuditInfo[i]['index'];
                    }
                    if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.iscontinuedblclick = true
                                that.code = row.Exclusively_ID
                                that.oldrow = row
                                that.getDetail(row.Exclusively_ID);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                            });
                    } else {
                        that.iscontinuedblclick = true
                        that.code = row.Exclusively_ID
                        that.oldrow = row
                        that.getDetail(row.Exclusively_ID);
                    }
                }, 100);
            },
            tableRowClassNameRight({ row, rowIndex }) {
            row.index = rowIndex;
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTlines.length;i++){
                delete datacopy.DTlines[i]['index'];
                    delete datacopy.DTlines[i]['pricearr'];
                }
                for(let i = 0;i<datacopy.DTAuditInfo.length;i++){
                delete datacopy.DTAuditInfo[i]['index'];
                }
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 0
                that.code = ''
                that.showError = false
                let date = that.$limits.getDateTime();
                that.dataDetail = {
                    IsEdit:1,//新增
                    Master:{
                        Exclusively_ID:0,
                        Doc_Num:'',
                        Doc_Ver:'',
                        Item_Type:0,
                        Doc_Type:0,
                        Doc_Reason:0,
                        Doc_Reason_Remark:'',
                        Currency_Code:'',
                        Tax_Rate:0,
                        Status:0,
                        Create_person:that.user,
                        Create_time:'',
                        Modify_person:'',
                        Modify_time:'',
                        Item_Name:'',
                        Item_Code:'',
                        Vender_Name:'',
                        Vender_Code:'',
                        Customer_Name:'',
                        Customer_ID:'',
                        vender_Part_Code:'',
                        Audit_Person:''
                },
                DTlines:[],
                DTAuditInfo:[]
                }
                that.fileList = [],
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            addline() {
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Master.Vender_Code)){
                    that.$message.warning(that.$t('getapi[1252]'));//'供应商代码必填!'
                    return;
                }
                let Relation_IID_Temp=0;
                if(!that.$limits.fnIsEmpty(that.dataDetail.Master.Exclusively_ID)){
                    Relation_IID_Temp = that.dataDetail.Master.Exclusively_ID;
                }
                let deti = {
                    Exclusively_ID:0,
                    Relation_IID:Relation_IID_Temp,
                    part_id:0,
                    part_code:'',
                    part_name:'',
                    Old_Unit_Price:'',
                    New_Unit_Price:'',
                    MOQ:'',
                    batch_floor_limit:'',
                    price:'',
                    net_price:'',
                    Shipment_Cycle:'',
                    PriceEffective_Date:'',
                    Remarks:'',
                    Item_Name:'',
                    Item_Code:'',
                    Doc_Type:0,
                    Old_Currency_Code:'',
                    New_Currency_Code:'',
                    isFirstVender:false,
                    Vender_Name:'',
                    Vender_Code:'',
                    part_version:'',
                    Process_Remark:'',
                    Status:0,
                    ischecked:true,
                    LineAuidtIID:0,
                    userid:0,
                    MainRelation_IID:0,
                    LineAuidtRelation_IID:0,
                    Err_Msg:'',
                    No_AuditPerson:'',
                    routing_sequence_no:'',
                    Routing_Version:'',
                    Routing_Name:'',
                    Routing_Relation_No:''
                };
                that.dataDetail.DTlines.push(deti);
            },
            // 刷新
            reflash() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTlines.length;i++){
                delete datacopy.DTlines[i]['index']
                    delete datacopy.DTlines[i]['pricearr'];
                }
                for(let i = 0;i<datacopy.DTAuditInfo.length;i++){
                delete datacopy.DTAuditInfo[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(that.dataDetail)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(!that.$limits.fnIsEmpty(that.dataDetail.Master.Exclusively_ID)){
                                that.getDetail(that.dataDetail.Master.Exclusively_ID);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    that.getView();
                    if(!that.$limits.fnIsEmpty(that.dataDetail.Master.Exclusively_ID)){
                        that.getDetail(that.dataDetail.Master.Exclusively_ID);
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            caculateTax(scope){
                let that = this;
                let dindex = scope.$index;
                that.dataDetail.DTlines[dindex].price = (scope.row.net_price*(1+that.dataDetail.Master.Tax_Rate/100)).toFixed(2);
                if(!that.$limits.fnIsEmptyRemove0(scope.row.batch_floor_limit) || !that.$limits.fnIsEmptyRemove0(scope.row.MOQ2)){
                    scope.row.linestatus=2;
                    scope.row.New_Unit_Price = ''
                    scope.row.MOQ = ''
                }
                else  scope.row.linestatus = 1;
            },
            selectRouting(row){
                let that = this;
                that.rowindex  = row.$index
                if (that.$limits.fnIsEmpty(row.row.part_code)) {
                    that.$message.warning(that.$t('getapi[8793]'));//'请选择物料！'
                    return;
                }
                let param = {
                    part_code: row.row.part_code,
                    part_version: row.row.part_name,
                    PUBPart_ID: row.row.part_id
                }
                that.$refs.Rounting.clearInput(true,param);
            },
            //工序信息填写
            getRounting(data){
                let that = this;
                console.log(data)
                that.dataDetail.DTlines[that.rowindex].routing_sequence_no = data.routing_sequence;
                that.dataDetail.DTlines[that.rowindex].RoutingVersion = data.routing_version;
                that.dataDetail.DTlines[that.rowindex].Routing_Name = data.workproc_name;
                that.dataDetail.DTlines[that.rowindex].Process_Remark = data.workproc_description
                console.log(that.dataDetail.DTlines[that.rowindex].routing_sequence_no)
            },
            //委外选择物料后加入到明细
            getpartt(data){
                let that = this;
                let obj = {
                        num: 0,
                        Quotation_num: that.dataDetail.num,
                        Part_ID: that.dataDetail.Part_ID,
                        ListPart_ID: data.exclusively_id,
                        ListPart_routing_ID: 0,
                        ListPart_Cost: data.Column1,
                        ListPart_Qty: data.mount,
                        ListPart_MTL_CODE: data.part_code,
                        ListPart_MTL_NAME: data.part_name,
                        ListPart_MTL_CUR_EDITION: data.part_version,
                        ListPart_RoutingName: "",
                        ListPart_MTL_MASTER_UNIT: data.part_master_unit
                    }
                that.dataDetail.Lists.push(obj);
            },
            selectcus(){
                let that = this;
                that.$refs.customer.clearInput(true);
            },
            selectproject(row) {
                let that = this;
                that.rowindex  = row.$index
                that.$refs.project.clearInput(true, false, 0);
            },
            selectsupplier(){
                let that = this;
                that.$refs.supplier.clearInput(true);
            },
             selectemployee(type, row) {
                let that = this;
                that.$refs.employee.clearInput(true,);
                
            },
            delbatch(indexx){
                let that = this;
                that.dataDetail.DTAuditInfo.splice(indexx,1);
            },
            getemployee(data){
                let that = this;
                console.log(data);
                for(let i=0;i<data.length;i++){
                    let obj={
                        Exclusively_ID:'',
                        Relation_IID:that.dataDetail.Master.Exclusively_ID,
                        Sort:that.sort,
                        Audit_Person:data[i].name,
                        userID:data[i].code,
                        Audit_Status:0,
                        Audit_Date:'',
                        Audit_Msg:''
                    }
                    that.dataDetail.DTAuditInfo.push(obj);
                    that.sort++;
                }
            },
            getsupplier(data){
                let that = this;
                //console.log(data)
                if(that.dataDetail.Master.Vender_Code != data.vender_code&& that.dataDetail.Master.Vender_Code != null&&that.dataDetail.DTlines.length>0){
                    //如果供应商有变化 
                    //提示
                    this.$confirm(that.$t('getapi[8600]'), that.$t('getapi[194]'), {//'检测到供应商发生变化，以下料表将被清空，是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.dataDetail.DTlines=[];
                        that.dataDetail.Master.Vender_Code = data.vender_code;
                        that.dataDetail.Master.Vender_Name = data.vender_name;
                        that.dataDetail.Master.Tax_Rate = data.tax_rate;
                        that.dataDetail.Master.Currency_Code = data.currency_code
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[6096]')
                        });
                    });
                } else {
                    that.dataDetail.Master.Vender_Code = data.vender_code;
                    that.dataDetail.Master.Vender_Name = data.vender_name;
                    that.dataDetail.Master.Tax_Rate = data.tax_rate;
                    that.dataDetail.Master.Currency_Code = data.currency_code
                }
            },
            CalTaxPrice(e){
                let that =this;
                that.dataDetail.OldUnitPrice = that.dataDetail.Unit_Price;
                let price = e * (1 + that.dataDetail.Tax_Rate/100);
                that.dataDetail.Unit_Price = price.toFixed(2);
            },
            commitup(){
                let that = this;
                let parm = that.dataDetail.Master;
                if(that.dataDetail.Master.Exclusively_ID==0){
                    that.$message.warning(that.$t('getapi[8805]'));//请先保存数据
                    return;
                }
                if(that.dataDetail.DTAuditInfo.length==0||that.dataDetail.DTlines.length==0){
                    return;
                }
                let strarr = '';
                let num1 = '';
                let num2 = '';
                for(let i=0;i<that.dataDetail.DTlines.length;i++){
                    if(!that.$limits.fnIsEmpty(that.dataDetail.DTlines[i].PriceRemark) &&
                        !that.$limits.fnIsEmpty(that.dataDetail.DTlines[i].Area) &&
                        !that.$limits.fnIsEmpty(that.dataDetail.DTlines[i].New_Unit_Price)){
                        num1 = that.$processdata.mathRound4(that.dataDetail.DTlines[i].PriceRemark * that.dataDetail.DTlines[i].Area)
                        num2 = that.$processdata.mathRound4(that.dataDetail.DTlines[i].New_Unit_Price)
                        if(num1 != num2){
                            strarr = strarr + that.$t('getapi[530]')+(i+1)+that.$t('getapi[532]')+','+
                                that.$t('getapi[13073]')+'('+num1+')'+that.$t('getapi[13074]')+ '('+num2+')'+','
                        }

                    }
                }
                if(strarr != ''){
                    this.$confirm(strarr + that.$t('getapi[13075]'), that.$t('getapi[194]'), {
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            let tmps = parm.Status;
                            parm.Status = 1;
                            parm.LangType = that.$processdata.getLang()
                            that.btn.commitbtn = false
                            that.$http.urlpost('/ISS/PQAudit/ISSQAuditSetStatus', parm, function (res) {
                                if (res.Success == 1) {
                                    that.getDetail(res.UniqueNum);
                                    that.$message.success(that.$t('getapi[8806]'));//'提交成功！'
                                    that.showError = false
                                }else{
                                    that.dataDetail.Master.Status = tmps;
                                    that.showError = true
                                    that.btn.commitbtn = true
                                }
                            });
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    let tmps = parm.Status;
                    parm.Status = 1;
                    parm.LangType = that.$processdata.getLang()
                    that.btn.commitbtn = false
                    that.$http.urlpost('/ISS/PQAudit/ISSQAuditSetStatus', parm, function (res) {
                        if (res.Success == 1) {
                            that.getDetail(res.UniqueNum);
                            that.$message.success(that.$t('getapi[8806]'));//'提交成功！'
                            that.showError = false
                        }else{
                            that.dataDetail.Master.Status = tmps;
                            that.showError = true
                            that.btn.commitbtn = true
                        }
                    });
                }
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]')//'生成';
                } else if (val == 1) {
                    return that.$t('getapi[8057]')//'审核中';
                } else if (val == 2) {
                    return that.$t('getapi[5160]')//'批准';
                } else if (val == 3) {
                    return that.$t('getapi[5161]')//'驳回';
                } else {
                    return '';
                }
            },
            // 批量选择
            handleSelectionChange(val) {
                let that = this;
                that.multipleSelection = val;
                that.btnauthority();
            },
            // 批量选择
            handleSelectionChangeM(val) {
            let that = this;
            that.multipleSelectionMain = val;
                that.btnauthority();
            },
            tableRowClassName({ row, rowIndex }) {
                row.index = rowIndex;
            },
            tableRowClassNameM({ row, rowIndex }) {
                row.index = rowIndex;
            },
            delline() {
                let that = this;
                if(that.multipleSelectionMain.length==0)return;
                let param = {
                    ids: "",
                }
                for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                    param.ids = param.ids+that.multipleSelectionMain[i].Exclusively_ID+',';
                }
                param.ids = param.ids.substring(0,param.ids.length-1);
                //硬删除
                that.$confirm(that.$t('getapi[8609]'), that.$t('getapi[194]'), {//确定要删除行吗
                    confirmButtonText: that.$t('getapi[2052]'),
                    cancelButtonText: that.$t('getapi[2053]'),
                    type: 'warning'
                })
                    .then(() => {
                        that.btn.delline = false;
                        that.$http.urlpost('/ISS/PQAudit/DelISSQAuditLineByID', param, function (res) {
                            that.btn.delline = true;
                            if (res.Success == 1) {
                                for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                                    that.dataDetail.DTlines.splice(that.multipleSelectionMain[i].index, 1);
                                }
                                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //导入
            imp() {
            let item = {
            label: '通用导入',
            name: 'exp',
            path: '/exp/26',
            url: '/exp/26',
            icon: 'video-play'
            };
            this.$router.push({ path: '/exp/26' });
            this.$store.commit('selectMenu', item);
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac
                };
                that.loading = true;
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/ISS/PQAudit/ISSQAuditExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    that.loading = false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "SchQuotationAuditViewInfo",
                    fromname: that.$t('getapi[6561]'),
                    SelectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)*/
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail;
                if(that.dataDetail.DTlines.length==0){
                    that.$message.warning(that.$t('getapi[8807]'));//"请填写请示内容！"
                    return;
                }
                parm.LangType = that.$processdata.getLang()
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/ISS/PQAudit/SaveISSQAudit', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[3153]'));//"保存成功！"
                        that.getView();
                        that.getDetail(res.UniqueNum);
                        that.showError = false
                    } else {
                        that.showError = true
                        that.dataDetail.DTlines = res.DataContent
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });
            },
            //删单
            delall(){
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Master.Exclusively_ID))return;
                let param = {
                    ids: that.dataDetail.Master.Exclusively_ID,
                }
                that.$refs.SetBtn.SetOneBtnEnable('del',false);
                that.$http.urlpost('/ISS/PQAudit/DelISSQAuditByID', param, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('del',true);
                    if (res.Success == 1) {
                        that.getView();
                        that.confirmAdd();
                        that.$message.success(that.$t('getapi[659]'));//'删除成功'
                    }
                });
            },
            batchDel(){
                let that = this
                that.$confirm(that.$t('getapi[8594]'), that.$t('getapi[194]'), {//'此操作将永久删除该数据, 是否继续?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let ids = ''
                        for(let i=0;i<that.multipleSelection.length;i++){
                            ids = ids + that.multipleSelection[i].Exclusively_ID + ','
                        }
                        ids = ids.substring(0, ids.length - 1);
                        let parm = {
                            ids: ids
                        };
                        that.$http.urlpost('/ISS/PQAudit/DelIssQAuditBatch', parm, function(res) {
                            that.getView();
                            that.confirmAdd();
                            that.$message.success(that.$t('getapi[659]'));//'删除成功'
                        });
                    })
                    .catch(() => {});

            },
            getDetail(code) {
                let that = this;
                that.addoredit = 1;
                that.IsEditPrice = true;
                that.loading1 = true;
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/ISS/PQAudit/ISSQAuditInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.ReflashLineStatus();
                        that.dataDetail.IsEdit=0;
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        if(that.dataDetail.DTlines){
                            for(let i = 0 ;i<that.dataDetail.DTlines.length;i++){
                                for(let j = 0;j<that.linepricearr.length;j++){
                                    if(that.dataDetail.DTlines[i].Routing_Name == that.linepricearr[j].name){
                                        that.dataDetail.DTlines[i].pricearr = that.linepricearr[j].data
                                        continue
                                    }
                                }
                            }
                        }
                        that.authority();
                        that.btnauthority();
                    }
                    that.loading1 = false;
                    loadingInstance.close()
                });
            },
            SetLineStatus1(scope){
                let that = this;
                if(!that.$limits.fnIsEmptyRemove0(scope.row.New_Unit_Price) || !that.$limits.fnIsEmptyRemove0(scope.row.MOQ)){
                    scope.row.linestatus=1;
                    scope.row.batch_floor_limit = ''
                    scope.row.MOQ2 = ''
                }
                else  scope.row.linestatus = 2;
               
            },
            SetLineStatus2(scope){
                let that = this;
                if(!that.$limits.fnIsEmptyRemove0(scope.row.batch_floor_limit) || !that.$limits.fnIsEmptyRemove0(scope.row.MOQ2)){
                    scope.row.linestatus=2;
                    scope.row.New_Unit_Price = ''
                    scope.row.MOQ = ''
                }
                else  scope.row.linestatus = 1;
               
            },
            ReflashLineStatus(){
                 let that = this;
                for(let i=0;i<that.dataDetail.DTlines.length;i++){
                if(!that.$limits.fnIsEmptyRemove0(that.dataDetail.DTlines[i].New_Unit_Price) || !that.$limits.fnIsEmptyRemove0(that.dataDetail.DTlines[i].MOQ))that.dataDetail.DTlines[i].linestatus=1;
                else  that.dataDetail.DTlines[i].linestatus = 2;
                }
                 
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            sr_code : that.dataDetail.Head.sr_code,
                            sr_status:that.dataDetail.Head.sr_status
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pro/SR/DelSr', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {

                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                        
                    });
            },
            //获取物料
            selectpart(row) {
                let that = this;
                this.partindex = row.$index;
                if(that.dataDetail.Master.Doc_Type==0){
                //新订零件
                if(that.$limits.fnIsEmpty(that.dataDetail.Master.Vender_Code))return;
                /*let param = {
                vender_code:that.dataDetail.Master.Vender_Code
                }*/
                that.$refs.part.clearInput(true);

                }else{
                //接续零件
                 that.$refs.part.clearInput(true);
                }
            },
            getpart(data){
            let that = this
            console.log(data)
            that.dataDetail.DTlines[that.partindex].linestatus = 0;
            that.dataDetail.DTlines[that.partindex].part_id = data.exclusively_id;
            that.dataDetail.DTlines[that.partindex].part_name = data.part_name;
            that.dataDetail.DTlines[that.partindex].part_version = data.part_version;
            that.dataDetail.DTlines[that.partindex].part_code = data.part_code;
            that.dataDetail.DTlines[that.partindex].ce_flag = data.ce_flag;            
            that.dataDetail.DTlines[that.partindex].Pur_MeasurementUnit = data.part_master_unit;
            that.dataDetail.DTlines[that.partindex].Cost_Std = data.cost_std;
            let hasPart = false;
            for(let i=0;i<that.dataDetail.DTlines.length;i++){
                if(that.partindex!=i){
                    if(that.dataDetail.DTlines[i].relation_p_part_id==data.exclusively_id&&!that.$limits.fnIsEmptyRemove0(that.dataDetail.DTlines[i].MOQ)){
                        hasPart = true;
                        that.dataDetail.DTlines[that.partindex].linestatus = 2;
                        break;
                    }
                }
            }
            },


            selectitem() {
                let that = this;
                that.$refs.item.clearInput(true);
            },
            downloadModel(){
                let that = this
                let param={
                    url:'/ISS/PQAudit/GetTSchQModelImportTemplat'
                }
                Array.methods.DownLoadTemp(param);
            },
            handleChange(file, fileList) {
                let that = this;
            },
            handleSuccess(res, file, fileList) {
                let that = this;
                let response = res.Success;
                if (response == 0) {
                    that.$message.error(that.$processdata.explainCallbackMsg(res.Msg));
                } else {
                    let data = res.DataContent.Lists
                    for (let i = 0; i < data.length; i++) {
                        that.dataDetail.DTlines = [...that.dataDetail.DTlines,{
                            Exclusively_ID:0,
                            Relation_IID:that.dataDetail.Master.Exclusively_ID,
                            part_id:data[i].part_id,
                            part_code:data[i].part_code,
                            part_name:data[i].part_name,
                            Old_Unit_Price:data[i].Old_Unit_Price,
                            New_Unit_Price:data[i].New_Unit_Price,
                            MOQ:data[i].MOQ,
                            batch_floor_limit:data[i].batch_floor_limit,
                            price:data[i].price,
                            net_price:data[i].net_price,
                            Shipment_Cycle:data[i].Shipment_Cycle,
                            PriceEffective_Date:data[i].PriceEffective_Date,
                            Remarks:data[i].Remarks,
                            Item_Name:data[i].Item_Name,
                            Item_Code:data[i].Item_Code,
                            Doc_Type:data[i].Doc_Type,
                            Old_Currency_Code:data[i].Old_Currency_Code,
                            New_Currency_Code:data[i].New_Currency_Code,
                            isFirstVender:data[i].isFirstVender,
                            Vender_Name:data[i].Vender_Name,
                            Vender_Code:data[i].Vender_Code,
                            part_version:data[i].part_version,
                            Process_Remark:data[i].Process_Remark,
                            Status:data[i].Status,
                            ischecked:data[i].ischecked,
                            LineAuidtIID:data[i].LineAuidtIID,
                            userid:data[i].userid,
                            MainRelation_IID:data[i].MainRelation_IID,
                            LineAuidtRelation_IID:data[i].LineAuidtRelation_IID,
                            Err_Msg:data[i].Err_Msg,
                            No_AuditPerson:data[i].No_AuditPerson,
                            routing_sequence_no:data[i].routing_sequence_no,
                            Routing_Version:data[i].Routing_Version,
                            Routing_Name:data[i].Routing_Name,
                            Routing_Relation_No:data[i].Routing_Relation_No
                        }]
                    }
                }
            },
            handleError(err, file, fileList) {
                let that = this;
                that.$message.error(that.$t('getapi[8585]')+':' + err);//上传失败
            },
            handleRemove(file, fileList) {
                console.log(file, fileList);
            },
            handlePreview(file) {
                console.log(file);
            },
            expDocType(val){
                if(val == 0){
                    return '新订零件'
                } else if(val == 1){
                    return '接续零件'
                } else {
                    return ''
                }
            },
            // 排序
            sortChange(column){
                let that = this
                let name = column.prop
                console.log(column)
                if(column.order == "ascending"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataDetail.DTlines.indexOf(obj1) - that.dataDetail.DTlines.indexOf(obj2);
                        }
                    }
                    that.dataDetail.DTlines = that.dataDetail.DTlines.sort(compare);
                } else if(column.order == "descending"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataDetail.DTlines.indexOf(obj2) - that.dataDetail.DTlines.indexOf(obj1);
                        }
                    }
                    that.dataDetail.DTlines = that.dataDetail.DTlines.sort(compare);
                }
            },
            //获取汇率信息
            getExchangeRate(){
                let that = this;
                let time = Common.methods.getDate()
                let datac = [];
                datac.push({
                    query_Condition: ">="+time,
                    query_field_type: 'date',
                    query_field_name: "invalid_date",
                    query_sort: "",
                    row_sign: ""
                });
                let data = {
                    PageIndex: 1,
                    PageSize: 100000,
                    Param: datac
                };
                that.$http.urlpost('Basic/General/GetExchangeRateList', data, function(res) {
                    console.log(res);
                    if (res.Success == 1) {
                        that.changeRateArr = res.DataContent;
                    }
                });
            },
            getRiseAndFallRate(data){
                let that = this
                let oldprice = data.Old_Unit_Price;
                let newprice = data.New_Unit_Price;
                let netprice = data.net_price
                for(let i = 0;i<that.changeRateArr.length;i++){
                    if(data.Old_Currency_Code == that.changeRateArr[i].foreign_currency_code){
                        oldprice = that.changeRateArr[i].exchange_rate * data.Old_Unit_Price
                    }
                    if(data.New_Currency_Code == that.changeRateArr[i].foreign_currency_code){
                        newprice = that.changeRateArr[i].exchange_rate * data.New_Unit_Price
                        netprice = that.changeRateArr[i].exchange_rate * data.net_price
                    }
                }
                if(that.$limits.fnIsEmpty(netprice) && (newprice / oldprice) > 1){
                    return (((newprice / oldprice * 10000) / 100.00) - 100).toFixed(2)
                }
                if(that.$limits.fnIsEmpty(netprice) == false && (newprice / oldprice) > 1){
                    return ((( oldprice - newprice)/ newprice * 10000) / 100.00).toFixed(2)
                }
                if(that.$limits.fnIsEmpty(netprice) && (newprice / oldprice) < 1){
                    return (((newprice / oldprice * 10000) / 100.00) - 100).toFixed(2)
                }
                if(that.$limits.fnIsEmpty(netprice) == false && (newprice / oldprice) < 1){
                    return (((oldprice - netprice) / netprice * 10000) / 100.00).toFixed(2)
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 522,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTlines.length;i++){
                delete datacopy.DTlines[i]['index']
                    delete datacopy.DTlines[i]['pricearr'];
                }
                for(let i = 0;i<datacopy.DTAuditInfo.length;i++){
                delete datacopy.DTAuditInfo[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(that.dataDetail)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	overflow-x: auto;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
			margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
	}
}
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
